module.exports = "https://asset.exam-sp.com/release/edm-score/webapp/img/homebg.eda68e26.png";